import React, { useEffect,useState }  from "react";
import Banner from "components/banner";
import user from "containers/user";
import { LineBreak } from "components/shared/layout";
import Button from "components/button";
import {
  RightCol,
  BannerContent,
  BannerTitle,
  BannerSubtitle,
  BannerParagraph,
  Graphic,
  GraphicContainer,
  GraphicMobile,
  InnerRow,
  HostedByRow,
  TitleCol,
  ButtonWrapper,
  Logo,
} from "./styles";


const View = (props) => {

const sections = ['Business Information', 'Finance', 'Staffing',
                  'Marketing', 'Operational Management', 'Information Technology']
const [selectedSection, setSelectedSection] = useState(sections[0])

useEffect(() => {
  if(props.isOnRequirementPage === undefined){
    const interval = setInterval(()=> { 
      setSelectedSection(sections[Math.floor(Math.random()*sections.length)])
    }, 30000);
    return () => {
      clearInterval(interval);
    };
  }
}, [])

const TaskBanner = ({ onRedeem, isOnRequirementPage=false }) => (
  <Banner variant="zltoDarkBlue">
    <BannerContent>
      <TitleCol>
        <BannerSubtitle>{`Welcome ${user.state.profile?.name}!`}</BannerSubtitle>
        <BannerTitle>
          {props.isOnRequirementPage
            ? <div>Work on your business by <LineBreak /> completing this section and  <LineBreak /> <span> earn Zlto.</span> </div>
            : <div>Have you completed <LineBreak /> the <span>{selectedSection} Section?</span> </div>
          }
        </BannerTitle>
        <BannerParagraph>
          Earn up to <strong>500 ZLTO</strong> when you complete this section!
        </BannerParagraph>
      </TitleCol>
      <InnerRow>
        <GraphicContainer>
          <Graphic />
        </GraphicContainer>
        <RightCol>
          {/* <ButtonWrapper>
            <Button variant='zltoLightBlue' onClick={onRedeem}>Redeem my rewards</Button>
          </ButtonWrapper> */}
          {/* <HostedByRow>
            <BannerParagraph>Hosted by</BannerParagraph>
            <Logo src={require("assets/images/cartedo-logo.svg")} />
          </HostedByRow> */}
        </RightCol>
      </InnerRow>
    </BannerContent>
  </Banner>
);


  return (
    <>
      <TaskBanner />
    </>
  );

}

export default View;
